import React from "react";
import { FileText, Clipboard } from "lucide-react";

interface GenerateDocumentButtonsProps {
  hasAnalyses: boolean;
  hasMedications: boolean;
  onGenerateAnalyses: () => void;
  onGeneratePrescription: () => void;
  prescriptionNumber?: string;
}

const GenerateDocumentButtons: React.FC<GenerateDocumentButtonsProps> = (
  props
) => {
  const {
    hasAnalyses,
    hasMedications,
    onGenerateAnalyses,
    onGeneratePrescription,
  } = props;
  return (
    <div className="flex flex-col sm:flex-row gap-4 mt-6">
      {hasAnalyses && (
        <button
          onClick={onGenerateAnalyses}
          className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition duration-200 font-medium"
        >
          <Clipboard size={20} />
          Générer demande d'analyses
        </button>
      )}

      {hasMedications && (
        <button
          onClick={onGeneratePrescription}
          className={`flex items-center justify-center gap-2 px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg transition duration-200 font-medium`}
        >
          <FileText size={20} />
          Générer ordonnance
        </button>
      )}
    </div>
  );
};

export default GenerateDocumentButtons;
